const SUPPLIERINFO_KEY = 'SCM_SUPPLIER_INFO';
const CLIENTINFO_KEY = 'SCM_CLIENT_INFO';

// 判断是否登录
const isLoginBySupplier = () => {
  return !!localStorage.getItem(SUPPLIERINFO_KEY);
};

const getSupplierInfo = () => {
  const supplierInfo = localStorage.getItem(SUPPLIERINFO_KEY);
  if (supplierInfo) {
    return JSON.parse(supplierInfo);
  }
  return supplierInfo;
};

const setClientInfo = (clientInfo: any) => {
  localStorage.setItem(CLIENTINFO_KEY, JSON.stringify(clientInfo));
};

const getClientInfo = () => {
  const clientInfo = localStorage.getItem(CLIENTINFO_KEY);
  if (clientInfo) {
    return JSON.parse(clientInfo);
  }
  return clientInfo;
};

const setSupplierInfo = (supplierInfo: any) => {
  localStorage.setItem(SUPPLIERINFO_KEY, JSON.stringify(supplierInfo));
};

// 退出登录时清清除掉加工厂和品牌方的信息
const clear = () => {
  localStorage.removeItem(SUPPLIERINFO_KEY);
  localStorage.removeItem(CLIENTINFO_KEY);
};

export {
  isLoginBySupplier,
  getSupplierInfo,
  setSupplierInfo,
  getClientInfo,
  setClientInfo,
  clear,
};
